import { createSelector } from '@ngrx/store';

import { getOrderBuilderState } from '@ordersnproducts/modules/order-builder/reducers/index';
import { RecipeFormValues } from '@ordersnproducts/modules/order-builder/modules/retail-specification/models/form-values';
import { FormSnapshot } from '@ordersnproducts/modules/order-builder/modules/rms-specification/reducers/open-platform/forms-snapshots.reducer';

const getRmsSpecificationPage = createSelector(getOrderBuilderState, state => {
  return state.rmsSpecificationPage;
});

const getFormsSnapshotsOpenPlatformState = createSelector(getRmsSpecificationPage, state => {
  return state.formsSnapshotsOpenPlatformState;
});

export const getFormsSnapshotsOpenPlatform = createSelector(getFormsSnapshotsOpenPlatformState, state => {
  const recipes: RecipeFormValues[] = [];
  for (const key in state.entities) {
    if (Object.prototype.hasOwnProperty.call(state.entities, key)) {
      recipes.push(state.entities[key].snapshot);
    }
  }
  return recipes;
});

export const getFormsSnapshotsOpenPlatformEntities = createSelector(getFormsSnapshotsOpenPlatformState, state => {
  const recipes: FormSnapshot[] = [];
  for (const key in state.entities) {
    if (Object.prototype.hasOwnProperty.call(state.entities, key)) {
      recipes.push(state.entities[key]);
    }
  }
  return recipes;
});
